import { useToast } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useLocalization } from '~/framework';

export type ErrorMessages<ErrorCode extends string> = Record<ErrorCode, string> & {
   default: string;
};

export function useApiErrorMessageToast<ErrorCode extends string>(
   errorMessages: ErrorMessages<ErrorCode>,
   isClosable?: boolean | undefined,
   status?: 'success' | 'error' | 'warning' | 'info' | 'loading' | undefined,
   duration?: number | undefined
) {
   const toast = useToast();
   const router = useRouter();
   const { _js } = useLocalization();
   const DEFAULT_STATUS = 'error';

   function handleError(error: any) {
      if (error?.response?.data) {
         const { code, message } = error.response.data;
         if (code && errorMessages && code in errorMessages) {
            toast({
               title: errorMessages[code as ErrorCode],
               status: status ?? DEFAULT_STATUS,
               position: 'top',
               isClosable: isClosable,
               duration: duration,
            });
         } else if (errorMessages?.default) {
            toast({
               title: errorMessages.default,
               status: status ?? DEFAULT_STATUS,
               position: 'top',
               isClosable: isClosable,
               duration: duration,
            });
         } else if (message) {
            toast({
               title: _js(message),
               status: status ?? DEFAULT_STATUS,
               position: 'top',
               isClosable: isClosable,
               duration: duration,
            });
         }
      }
   }

   function handleErrorOrRedirectToLogin(error: any) {
      if (error?.response?.code === 401) {
         router.push('/Login');
      } else {
         handleError(error);
      }
   }

   return {
      handleError,
      handleErrorOrRedirectToLogin,
   };
}
